import React, { useEffect, useState } from 'react';
import dayjs from 'dayjs';
import duration from 'dayjs/plugin/duration';

dayjs.extend(duration);

const CountDateDown = ({ endTime }: any) => {
  const [remainingTime, setRemainingTime] = useState('');
  useEffect(() => {
    const intervalId = setInterval(() => {
      const now = dayjs();
      const target = dayjs(endTime);
      const diff = target.diff(now);

      const days = target.diff(now, 'day');
      const hours = target.diff(now.add(days, 'day'), 'hour');
      const minutes = target.diff(now.add(days, 'day').add(hours, 'hour'), 'minute');

      if (diff > 0) {
        if (dayjs.duration(diff).asDays() > 1) {
          setRemainingTime(`${days}日 : ${hours}小时 : ${minutes}分`);
        } else {
          const remaining = dayjs.duration(diff);
          setRemainingTime(remaining.format('H小时 : mm分 : ss秒'));
        }
      } else {
        clearInterval(intervalId);
      }
    }, 1000);

    return () => clearInterval(intervalId);
  }, [endTime]);

  return <div>{remainingTime}</div>;
};

export default CountDateDown;